'use client';
import React, { useEffect, useRef } from 'react';
import styles from './ModalWrapper.module.scss';
import { ModalStatusEnum, useModalStatus, useModalStoreActions } from '@/store';

interface GlassModalProps {
	children: React.ReactNode;
	onClose: () => void;
	disableClose?: boolean;
}

const ModalWrapper = ({
	children,
	onClose,
	disableClose = false,
}: GlassModalProps) => {
	const modalRef = useRef<HTMLDivElement>(null);
	const { setModalStatus } = useModalStoreActions();
	const modalStatus = useModalStatus();

	useEffect(() => {
		if (modalStatus === ModalStatusEnum.WalletCurrencyDropdown) return;
		document.body.style.overflow = 'hidden';
		return () => {
			document.body.style.overflow = 'unset';
		};
	}, [modalStatus]);

	useEffect(() => {
		if (modalStatus == null) return;
		if (disableClose) return;
		const handleClickOutside = (event: MouseEvent) => {
			if (
				event.target instanceof Element &&
				event.target.id === 'glass-modal'
			) {
				onClose();
				setModalStatus(null);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [onClose, setModalStatus, modalStatus]);

	return (
		<div
			id="glass-modal"
			className={`${styles.glassModalContainer}  fixed z-[5000] flex justify-center inset-0 overflow-x-hidden overflow-y-scroll bg-[rgba(0,0,0,0.4)] backdrop-blur-[10px]`}
			ref={modalRef}
		>
			{children}
		</div>
	);
};

export default ModalWrapper;
